import { Component } from "react";
import { Switch, Route, Redirect } from 'react-router-dom';
import { TakeAssessmentList } from "../component/features/take-assessments/TakeAssessmentList";
import { TakeAssessment } from "../component/features/take-assessments/TakeAssessment";

export class TakeAssessmentRouter extends Component {
    
    render() {
        return (
            <Switch>
                <Route exact path={"/take-assessments"} component={TakeAssessmentList} />
                <Route exact path={"/take-assessments/:runAssessmentClientId"} component={TakeAssessment} />
                <Redirect to="/not-found" />
            </Switch>
        )
    }
};